
/*

sohel 09/30/2022  2700799562 Globalfieldlist ->Print Global List payload Changes
saikrishna 01/10/2023 2700799562  updated download configuration payload

*/


import {createSlice} from '@reduxjs/toolkit';
import download from '../../../util/DownloadLink';
import {httpPost} from '../../../util/Rest';

const initialData = {
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  usageData: {},
};

const slice = createSlice({
  name: 'usage',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
      state.successMsg = null;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.message;
      state.isLoading = false;
    },
    fetchUsage: (state, action) => {
      state.usageData = action.payload;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.message ?
        action?.payload?.data?.message :
        action?.payload?.data?.error ?
          action?.payload?.data?.error :
          '';
      state.isLoading = false;
    },
    resetData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.usageData = {};
    },
  },
});

export default slice.reducer;

// Actions

export const {fetchStart, fetchSuccess, fetchError, fetchUsage, resetData} = slice.actions;

export const postPrintUsage = (payload) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`framework/usage/print/frameworkusage`, {
      baseCategory: '',
      code: '',
      description: '',
      displayName: '',
      fileType: '',
      recordFormatType: '',
      returnType: '',
      sourceType: '',
      ...payload,
    })
      .then((data) => {
        if (data.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          download(data.response);
          dispatch(fetchSuccess(data));
          dispatch(fetchUsage(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const resetPrintUsageData = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};
